module.exports = __webpack_public_path__ + "static/sonomacounty-6fcadd298f19bb88d4f32b46d889b401.png";